import styled from "styled-components";

import { from, size, spacing } from "@runwayhealth/runway-components-react";

export const MainContent = styled.section`
  width: 100%;
  padding-bottom: ${spacing.sm};

  // From mobile smaller than the set at from.sm
  @media (min-width: 200px) {
    margin-top: 5%;
  }

  @media (${from.desktopL}) {
    margin-top: 2%;
  }
`;
